import { JOB_TITLE_UNAMBIGUOUS_ACRONYMS } from '@/core/constants/jobTitle';

export const normalizeUnambiguousAcronyms = (value: string): string =>
	value.replace(/\S+/g, word => {
		const upper = word.toUpperCase();
		return JOB_TITLE_UNAMBIGUOUS_ACRONYMS.has(upper) ? upper : word;
	});
